import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';

const ArrayOfStringsField = ({ source, record = {} }) => (
  <Typography
    variant="body1"
  >
    {record[source] && record[source].join(', ')}
  </Typography>
);

ArrayOfStringsField.propTypes = {
  source: PropTypes.string,
  record: PropTypes.object,
};

ArrayOfStringsField.defaultProps = {
  addLabel: true,
};

export default ArrayOfStringsField;

